<template>
  <v-app>
    <v-navigation-drawer
      persistent
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-img :aspect-ratio="16/9" :src="require('@/assets/ng-background-blue.png')">
        <v-layout pa-2 column fill-height class="lightbox white--text text-xs-center">
          <v-spacer></v-spacer>
          <v-flex shrink>
            <img :src="require('@/assets/client_logo.png')">
            <div class="subheading">{{ user.name }}</div>
            <div class="body-1">{{ user.email }}</div>
          </v-flex>
        </v-layout>
      </v-img>
      <v-list>
        <v-list-group
          no-action
          :prepend-icon="header.icon"
          value="true"
          v-for="(header, h) in navigation_headers"
          :key="h"
        >
          <v-list-tile slot="activator">
            <v-list-tile-title v-text="header.title"></v-list-tile-title>
          </v-list-tile>
          <v-list-tile
            v-for="(section, s) in header.sections"
            :key="s"
            :to="{path: section.path}"
          >
            <v-list-tile-title v-text="section.title"></v-list-tile-title>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <img height="45px" src="@/assets/logo.png" alt="NoiseGrasp">
      <v-toolbar-title v-text="$route.name"></v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-fade-transition mode="out-in">
        <router-view/>
      </v-fade-transition>
    </v-content>
  </v-app>
</template>

<script>

import data from '@/data'

export default {
  name: 'App',
  data () {
    return {
      drawer: true,
      navigation_headers: [{
        icon: 'info',
        title: 'Data',
        sections: []
      },
      {
        icon: 'insert_chart',
        title: 'Model',
        sections: [{
          title: 'Attribution',
          path: 'attribution'
        },
        {
          title: 'Recommendation',
          path: 'recommendation'
        },
        {
          title: 'Gains',
          path: 'gains'
        }
        ]
      }],
      right: true,
      rightDrawer: false
    }
  },
  components: {
    
  },
  computed: {
    user: function () {
      return data.user
    }
  },
  methods: {
  }
}
</script>
